import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["focus:outline-none rounded-full inline-flex", [_ctx.isLightMode() ? _ctx.lightModeClasses : _ctx.darkModeClasses]]),
    style: _normalizeStyle(`padding: ${_ctx.padding_top}px ${_ctx.padding_right}px ${_ctx.padding_bottom}px ${_ctx.padding_left}px`),
    onKeydown: _cache[0] || (_cache[0] = _withKeys(_withModifiers(($event: any) => (_ctx.click()), ["exact","prevent"]), ["enter"]))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(["material-icons my-auto", `${_ctx.iconSize} ${_ctx.iconColor}`])
    }, _toDisplayString(_ctx.icon), 3)
  ], 38))
}